module.exports = __webpack_public_path__ + "img/who-is-championla.8aa07953.jpg";